"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetsUrl = void 0;
const constants_1 = require("./constants");
/**
 * @param uuid UUID of the assets hosted on Uploadcare
 * @returns Full asset URL that can be used as a source for <img>, <video> and <a> tags.
 */
function getAssetsUrl(uuid) {
    return `${constants_1.ASSETS_URL}/${uuid}/`;
}
exports.getAssetsUrl = getAssetsUrl;
//# sourceMappingURL=getAssetsUrl.js.map